/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import SecondaryCheckbox from "Components/common/SecondaryCheckbox";
import makeApi, { URLS } from "Utils/apiURL";
import { MP_EVENT } from "Static/constant";
import { toasterState } from "Components/common/toaster";
import NumberInputBox from "Components/common/NumberInputBox";
import AutoCompleteDropdown from "Components/common/AutoCompleteDropdown";
import Button from "Components/common/Button";
import scheduleDataStore from "Stores/ScheduleData";
import { weekDays } from "Static/constant";
import MultiInboxSelection from "./MultiInboxSelection";
import { sequenceStoreData } from "Stores/sequenceData";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import userDetail from "Stores/userDetail";
import { initialSchedulePopupState } from "./InitialScheduleInfoPopup";
import { SequenceUtils } from "Utils/SequenceUtils";
import SchedulePresetList, { ScheduleOptionRow } from "./SchedulePresetList";
import CreateSchedulePopup from "./CreateSchedulePopup";

// Collapsed-by-default section card. The always-visible summary line states the
// section's current state in plain language; only editing controls are folded.
const CollapsibleSettingCard = props => {
  const {
    id = undefined,
    title = "",
    chip = null,
    summary = "",
    autoExpand = false,
    children
  } = props || {};

  const [open, setOpen] = useState(autoExpand);

  useEffect(() => {
    if (autoExpand) {
      setOpen(true);
    }
  }, [autoExpand]);

  return (
    <div id={id} className={`settingCard ${open ? "open" : ""}`}>
      <div className="settingCardHeader" onClick={() => setOpen(!open)}>
        <div className="settingCardHeadMain">
          <div className="settingCardTitleRow">
            <span className="settingCardTitle">{title}</span>
            {chip}
          </div>
          {!open && summary && (
            <div className="settingCardSummary">{summary}</div>
          )}
        </div>
        <div className="settingCardAction">
          {!open && <span className="editLabel">Edit</span>}
          <i className="material-icons settingCardChevron">
            {open ? "expand_less" : "expand_more"}
          </i>
        </div>
      </div>
      {open && <div className="settingCardBody">{children}</div>}
    </div>
  );
};

const SequenceThrottlingSettings = observer(props => {
  const {
    sequenceId = "",
    loader = false,
    setThrottlingData = () => {},
    setSavedChanges = () => {},
    accessType = false,
    dailyEnrollingCount,
    maximumActiveCount,
    scheduleWindowId = "",
    inboxIds: connectedInboxIds,
    isSharedSequence,
    reassignInbox = false,
    excludeContactEnabled = false,
    excludeActiveContactEnabled = false,
    emailValidationEnabled = false,
    stopEmailOnMeetingBooked = false,
    sequence = {},
    stopEmailOnReplyReceived = false,
    stopEmailOnLinkedInReplyReceived = false,
    ...remainingProps
  } = props || {};

  const { calendarEnabled = false } = userDetail?.userInfo || {};

  const { calendarIntegrationEnabled = false, liAutomationEnabled = false } =
    userDetail?.userFeatureFlag || {};

  const [maxOngoingContacts, setMaxOngoingContacts] =
    useState(maximumActiveCount);
  const [maxContactsAdd, setMaxContactsAdd] = useState(dailyEnrollingCount);
  const [isEnabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState("");
  const [activeErrMsg, setActiveErrMsg] = useState("");
  const [contactsEnrollErrMsg, setContactsEnrollErrMsg] = useState("");
  const [scheduleId, setScheduleId] = useState(scheduleWindowId);
  const [scheduleWindow, setScheduleWindow] = useState({});
  const [showCreateSchedulePopup, setShowCreateSchedulePopup] = useState(false);
  const [editSchedule, setEditSchedule] = useState(null);
  const [reAssignContact, setReAssignContact] = useState(reassignInbox);
  const [isInboxMappedToSequence, setIsInboxMappedToSequence] = useState(false);
  const [isContactExclusive, setContactExclusive] = useState(
    excludeContactEnabled
  );
  const [isActiveContactExclusive, setActiveContactExclusive] = useState(
    excludeActiveContactEnabled
  );
  const [isEmailValidationEnabled, setEmailValidationEnabled] = useState(
    emailValidationEnabled
  );
  const [isStopEmailOnMeetingBooked, setStopEmailOnMeetingBooked] = useState(
    stopEmailOnMeetingBooked
  );
  const [isStopEmailOnReplyReceived, setStopEmailOnReplyReceived] = useState(
    stopEmailOnReplyReceived
  );
  const [
    isStopEmailOnLinkedInReplyReceived,
    setIsStopEmailOnLinkedInReplyReceived
  ] = useState(stopEmailOnLinkedInReplyReceived);

  let tempWeekDays = [];

  const handleSetAction = (id = "", value = "") => {
    sequenceStoreData.setTempThrottlingData({
      ...sequenceStoreData?.tempThrottlingData,
      [id]: value
    });
  };

  const changeMaxOngoingContacts = value => {
    setEnabled(false);
    setMaxOngoingContacts(value);
    handleSetAction("maximumActiveCount", value);
  };

  const changeMaxContactsAdded = value => {
    setEnabled(false);
    setMaxContactsAdd(value);
    handleSetAction("dailyEnrollingCount", value);
  };

  const validCountRange = () => {
    return (
      maxContactsAdd > 0 &&
      maxContactsAdd <= 100000 &&
      maxOngoingContacts > 0 &&
      maxOngoingContacts <= 100000
    );
  };

  const getSelectedConnectedInboxIds = () => {
    return sequenceStoreData?.selectedConnectedInbox?.map(item => item.id);
  };

  const saveSequenceSetting = async () => {
    if (!loader && sequenceId && validCountRange()) {
      setLoading(true);
      const selectedInboxIds = getSelectedConnectedInboxIds();
      try {
        const config = {
          url: URLS.saveSequenceSetting,
          method: "POST",
          data: {
            id: sequenceId,
            scheduleWindowId: scheduleWindow?.id,
            settings: {
              dailyEnrollingCount: maxContactsAdd,
              maximumActiveCount: maxOngoingContacts
            },
            inboxIds: selectedInboxIds,
            reassignInbox: reAssignContact,
            excludeContactEnabled: isContactExclusive,
            excludeActiveContactEnabled: isActiveContactExclusive,
            emailValidationEnabled: isEmailValidationEnabled,
            stopEmailOnMeetingBooked: isStopEmailOnMeetingBooked,
            stopEmailOnReplyReceived: isStopEmailOnReplyReceived,
            stopEmailOnLinkedInReplyReceived: isStopEmailOnLinkedInReplyReceived
          }
        };
        const res = await makeApi(config);
        if (res?.data) {
          if (sequence && typeof sequence === "object") {
            sequence.scheduleWindowId = scheduleWindow?.id;
          }
          setEnabled(true);
          setThrottlingData({
            scheduleWindowId: scheduleWindow?.id,
            ...{
              dailyEnrollingCount: maxContactsAdd,
              maximumActiveCount: maxOngoingContacts,
              inboxIds: selectedInboxIds,
              excludeContactEnabled: isContactExclusive,
              excludeActiveContactEnabled: isActiveContactExclusive,
              emailValidationEnabled: isEmailValidationEnabled,
              stopEmailOnMeetingBooked: isStopEmailOnMeetingBooked,
              stopEmailOnReplyReceived: isStopEmailOnReplyReceived,
              stopEmailOnLinkedInReplyReceived:
                isStopEmailOnLinkedInReplyReceived
            }
          });
          setSavedChanges(true);
          setScheduleId(scheduleWindow?.id);
          toasterState.setToastMsg(
            "Succesfully updated the settings",
            "success"
          );
          Utils.mixpanelTrack(MP_EVENT.SQ_SETTING_SAVED, {
            pageType: "Sequence - Setting",
            sequenceId
          });
        } else if (res?.response?.status === 403) {
          confirmationPopupState.setPopupValues({
            content:
              "Failed. You do not have sufficient privileges to update this sequence. Please contact the sequence owner.",
            actionBtnText: "Ok",
            needCancelBtn: false,
            callback: () => {
              confirmationPopupState.setShowPopup(false);
            }
          });
          confirmationPopupState.setShowPopup(true);
        } else {
          toasterState.setToastMsg("Failed to update the settings", "fail");
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error("Failed on updating sequence throttling settings", err);
      }
    } else if (maxOngoingContacts < 1 || maxOngoingContacts > 100000) {
      setActiveErrMsg("Please enter a value between 1 to 100000");
      setTimeout(() => {
        setActiveErrMsg("");
      }, 1500);
    } else if (maxContactsAdd < 1 || maxContactsAdd > 100000) {
      setContactsEnrollErrMsg("Please enter a value between 1 to 100000");
      setTimeout(() => {
        setContactsEnrollErrMsg("");
      }, 1500);
    }
  };

  const submitAction = event => {
    Utils.isSubmitKeyAction(event) && saveSequenceSetting();
  };

  const settingsObjArr = [
    {
      type: "number",
      id: "maxmimumOngoingContacts",
      changeCbk: changeMaxOngoingContacts,
      min: 1,
      max: 100000,
      value: maxOngoingContacts,
      name: "maxmimumOngoingContacts",
      label: "Max contacts ongoing in this sequence",
      placeholder: "Enter the value between 1 to 100000",
      subText:
        "This number determines the maximum number of active contacts that can be in the sequence at a given time.",
      errMsg: activeErrMsg,
      readOnly: !accessType,
      submitCbk: submitAction,
      loader: loader
    },
    {
      type: "number",
      id: "maxmimumContactsAdded",
      changeCbk: changeMaxContactsAdded,
      min: 1,
      max: 100000,
      value: maxContactsAdd,
      name: "maxmimumContactsAdded",
      label: "Max contacts added to this sequence per 24-hour rolling period",
      placeholder: "Enter the value between 1 to 100000",
      subText:
        "This number determines the maximum number of contacts that can be activated and added to the first step of the sequence every 24 hours.",
      errMsg: contactsEnrollErrMsg,
      readOnly: !accessType,
      submitCbk: submitAction,
      loader: loader
    }
  ];

  const scheduleWindowCbk = item => {
    setScheduleWindow({ ...item });
    handleSetAction("scheduleWindowId", item?.id);
  };

  // Preset pick / inline create refetch the schedule store, which re-runs
  // getDefaultScheduleData; syncing scheduleId keeps the new pick from being
  // reverted to the previously saved schedule.
  const handleScheduleSelected = (schedule = {}) => {
    if (schedule?.id) {
      setScheduleId(schedule.id);
      scheduleWindowCbk(schedule);
    }
  };

  const getUpdatedTimeRange = () => {
    const dailyTimeRange = scheduleWindow?.dailyTimeRange;

    for (var day in weekDays) {
      const initialTimeRange = dailyTimeRange?.[day]?.map(item => {
        const { fromTime = "", toTime = "" } = item;
        return `${Utils.getCustomTime(fromTime)} - ${Utils.getCustomTime(
          toTime
        )}`;
      });

      tempWeekDays.push({
        long: weekDays[day]?.long,
        timeRange: initialTimeRange
      });
    }
    return tempWeekDays;
  };

  const getScheduleWindow = () => {
    const tempWeekDays = getUpdatedTimeRange();

    return tempWeekDays?.map((item, index) => {
      const { long = "", timeRange = [] } = item || {};
      return (
        <div
          className="daysWithTimeWrapper"
          key={`daysWithTimeWrapper${index}`}
        >
          <span className="weekDays">{long}</span>
          <span className={`TimeRange ${timeRange?.[0] ? "" : "emptyResult"}`}>
            {timeRange?.[0] || "--"}
          </span>
        </div>
      );
    });
  };

  const getDefaultScheduleData = () => {
    const tempData = scheduleDataStore?.scheduleData?.data;
    const filteredData = tempData?.filter(item => item.id === scheduleId)?.[0];
    setScheduleWindow({ ...filteredData });
    handleSetAction("scheduleWindowId", filteredData?.id);
    scheduleDataStore.setDefaultData({ ...filteredData });
  };

  const redirectToScheduleSettings = () => {
    Utils.mixpanelTrack(MP_EVENT.SQ_SETTING_HERE_CLICKED, {
      pageType: "Sequence - Setting",
      sequenceId
    });
    props.history.push("/settings/schedules");
  };

  const handleContactExcluded = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setContactExclusive(value);
      handleSetAction(id, value);
    }
  };

  const handleActiveContactExcluded = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setActiveContactExclusive(value);
      handleSetAction(id, value);
    }
  };

  const handleEmailValidation = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setEmailValidationEnabled(value);
      handleSetAction(id, value);
    }
  };

  const handleStopEmailOnMeetingBooked = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setStopEmailOnMeetingBooked(value);
      handleSetAction(id, value);
    }
  };

  const hanldeStopEmailOnReplyReceived = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setStopEmailOnReplyReceived(value);
      handleSetAction(id, value);
    }
  };

  const handleStopLinkedInOnReplyReceived = (value = "", id = "") => {
    if (id) {
      setEnabled(false);
      setIsStopEmailOnLinkedInReplyReceived(value);
      handleSetAction(id, value);
    }
  };

  const safetyCheckboxList = [
    {
      label:
        "Do not add contact to this sequence, if it is currently active on another sequence.",
      id: "excludeActiveContactEnabled",
      cbk: handleActiveContactExcluded,
      checked: isActiveContactExclusive,
      show: true
    },
    {
      label:
        "Do not add contact to this sequence, if it was previously added to another sequence.",
      id: "excludeContactEnabled",
      cbk: handleContactExcluded,
      checked: isContactExclusive,
      show: true
    },
    {
      label:
        "Validate the e-mail addresses before adding them to the sequence.",
      id: "emailValidationEnabled",
      cbk: handleEmailValidation,
      checked: isEmailValidationEnabled,
      show: true
    },
    {
      label: "Stop sequence when meeting booked.",
      id: "stopEmailOnMeetingBooked",
      cbk: handleStopEmailOnMeetingBooked,
      checked: isStopEmailOnMeetingBooked,
      show: calendarEnabled && calendarIntegrationEnabled
    },
    {
      label: "Stop sequence when an email reply is received.",
      id: "stopSequenceWhenReplyIsReceived",
      cbk: hanldeStopEmailOnReplyReceived,
      checked: isStopEmailOnReplyReceived,
      show: true
    },
    {
      label: "Stop sequence when a LinkedIn reply is received.",
      id: "stopLinkedInSequenceWhenReplyIsReceived",
      cbk: handleStopLinkedInOnReplyReceived,
      checked: isStopEmailOnLinkedInReplyReceived,
      show: liAutomationEnabled
    }
  ];

  // Inbox changes save instantly; everything else persists via Save Changes.
  // The sticky save bar appears only when the working copy differs from the
  // last saved values, making the two save models self-evident.
  const savedSettingValues = {
    dailyEnrollingCount,
    maximumActiveCount,
    scheduleWindowId,
    reassignInbox,
    excludeContactEnabled,
    excludeActiveContactEnabled,
    emailValidationEnabled,
    stopEmailOnMeetingBooked,
    stopEmailOnReplyReceived,
    stopEmailOnLinkedInReplyReceived
  };

  const hasUnsavedChanges = Object.keys(savedSettingValues).some(key => {
    const tempValue = sequenceStoreData?.tempThrottlingData?.[key];
    return (
      tempValue !== undefined &&
      String(tempValue) !== String(savedSettingValues[key])
    );
  });

  // ── Card summaries: plain-language, consequence-first, derived from data ──

  const connectedInboxCount =
    sequenceStoreData?.selectedConnectedInbox?.length || 0;
  const inboxRequired =
    SequenceUtils.checkEmailSteps(sequence) && !connectedInboxCount;

  const inboxSummary = !isInboxMappedToSequence
    ? "Loading..."
    : inboxRequired
    ? "No inbox connected. Emails cannot send."
    : connectedInboxCount
    ? `${connectedInboxCount} ${
        connectedInboxCount > 1 ? "inboxes" : "inbox"
      } connected · contacts split evenly`
    : "No inboxes connected yet.";

  const getScheduleSummary = () => {
    if (!scheduleWindow?.id) {
      return "Loading...";
    }
    const ranges = scheduleWindow?.dailyTimeRange || {};
    const activeDays = Object.keys(ranges)
      .filter(day => ranges[day]?.length)
      .sort();
    if (!activeDays.length) {
      return `${scheduleWindow?.name} · no sending window set`;
    }
    const firstRange = ranges[activeDays[0]]?.[0] || {};
    const sameRange = activeDays.every(day => {
      const range = ranges[day]?.[0] || {};
      return (
        ranges[day]?.length === 1 &&
        range?.fromTime === firstRange?.fromTime &&
        range?.toTime === firstRange?.toTime
      );
    });
    const contiguous = activeDays.every(
      (day, index) => index === 0 || +day === +activeDays[index - 1] + 1
    );
    const daysLabel =
      contiguous && activeDays.length > 1
        ? `${weekDays[activeDays[0]]?.short}-${
            weekDays[activeDays[activeDays.length - 1]]?.short
          }`
        : activeDays.map(day => weekDays[day]?.short).join(", ");
    const hoursLabel = sameRange
      ? `${Utils.getCustomTime(firstRange?.fromTime)} - ${Utils.getCustomTime(
          firstRange?.toTime
        )}`
      : "custom hours";
    return `${scheduleWindow?.name} · ${daysLabel}, ${hoursLabel}`;
  };

  const safeguardShortLabels = {
    stopSequenceWhenReplyIsReceived: "stops on reply",
    stopLinkedInSequenceWhenReplyIsReceived: "stops on LinkedIn reply",
    stopEmailOnMeetingBooked: "stops when meeting booked",
    excludeActiveContactEnabled: "skips contacts active in other sequences",
    excludeContactEnabled: "skips previously sequenced contacts",
    emailValidationEnabled: "validates emails first"
  };
  const activeSafeguards = Object.keys(safeguardShortLabels)
    .map(id => safetyCheckboxList.find(item => item?.id === id))
    .filter(item => item?.show && item?.checked)
    .map(item => safeguardShortLabels[item.id]);
  const shownSafeguardsCount = safetyCheckboxList.filter(
    item => item?.show
  ).length;
  const safeguardSummary = activeSafeguards.length
    ? `${activeSafeguards.length} of ${shownSafeguardsCount} on · ${activeSafeguards
        .slice(0, 2)
        .join(" · ")}${
        activeSafeguards.length > 2
          ? ` · +${activeSafeguards.length - 2} more`
          : ""
      }`
    : `0 of ${shownSafeguardsCount} on · sending continues even after a reply`;

  const limitsSummary = `Adds up to ${
    maxContactsAdd || "-"
  } contacts/day · max ${maxOngoingContacts || "-"} ongoing`;

  const constructInboxIds = () => {
    if (sequence?.inboxIds?.length) {
      const tempArr = [];
      let inboxes =
        Utils.createObjWithoutRef(userDetail?.connectedInboxes) || [];
      inboxes?.map((item = {}) => {
        const { id = "", email = "", status = "" } = item;
        if (sequence.inboxIds.includes(id) && status === "ACTIVE") {
          tempArr.push({ id: id, email: email });
        }
      });
      sequenceStoreData.setSelectedConnectedInbox(tempArr);
    } else {
      sequenceStoreData.setSelectedConnectedInbox([]);
    }
    setIsInboxMappedToSequence(true);
  };

  useEffect(() => {
    getDefaultScheduleData(scheduleDataStore?.scheduleData);
  }, [scheduleId, scheduleDataStore.scheduleData]);

  useEffect(() => {
    setMaxOngoingContacts(maximumActiveCount);
    setMaxContactsAdd(dailyEnrollingCount);
    setScheduleId(scheduleWindowId);
    setReAssignContact(reassignInbox);
    setContactExclusive(excludeContactEnabled);
    setActiveContactExclusive(excludeActiveContactEnabled);
    setEmailValidationEnabled(emailValidationEnabled);
    setStopEmailOnMeetingBooked(stopEmailOnMeetingBooked);
    setStopEmailOnReplyReceived(stopEmailOnReplyReceived);
    setIsStopEmailOnLinkedInReplyReceived(stopEmailOnLinkedInReplyReceived);
    sequenceStoreData.setTempThrottlingData({
      ...sequenceStoreData?.tempThrottlingData,
      dailyEnrollingCount,
      maximumActiveCount,
      scheduleWindowId,
      reassignInbox,
      excludeContactEnabled,
      excludeActiveContactEnabled,
      emailValidationEnabled,
      stopEmailOnMeetingBooked,
      stopEmailOnReplyReceived,
      stopEmailOnLinkedInReplyReceived
    });
  }, [
    dailyEnrollingCount,
    maximumActiveCount,
    scheduleWindowId,
    reassignInbox,
    excludeContactEnabled,
    excludeActiveContactEnabled,
    emailValidationEnabled,
    stopEmailOnMeetingBooked,
    stopEmailOnReplyReceived,
    stopEmailOnLinkedInReplyReceived
  ]);

  useEffect(() => {
    Utils.mixpanelTrack(MP_EVENT.SQ_SETTING_VIEWED, {
      pageType: "Sequence - Setting",
      sequenceId
    });
  }, []);

  useEffect(() => {
    if (typeof sequence?.inboxIds != "undefined") {
      constructInboxIds();
    }
  }, [sequence?.inboxIds, userDetail?.connectedInboxes]);

  return (
    <div className="sequenceSettingCards">
      <CollapsibleSettingCard
        title="Sending inboxes"
        chip={inboxRequired ? <span className="requiredChip">Required</span> : null}
        summary={inboxSummary}
        autoExpand={inboxRequired}
      >
        <MultiInboxSelection
          sequence={sequence}
          sequenceMemberId={sequence?.memberId}
          sequenceId={sequenceId}
          connectedInboxIds={connectedInboxIds}
          isSharedSequence={isSharedSequence}
          reAssignContact={reAssignContact}
          setReAssignContact={setReAssignContact}
          isInboxMappedToSequence={isInboxMappedToSequence}
          {...remainingProps}
          showHeader={false}
        />
      </CollapsibleSettingCard>
      <CollapsibleSettingCard
        id="scheduleSettingCard"
        title="Schedule"
        chip={
          scheduleWindow?.default ? (
            <span className="defaultChip">Default</span>
          ) : null
        }
        summary={getScheduleSummary()}
      >
        <div className="sequenceScheduleSettings">
          <p className="subTextForSettings">
          Emails and tasks go out only during the sending window below.{" "}
          <button className="hereText" onClick={redirectToScheduleSettings}>
            Manage schedules
          </button>
        </p>
        <div className="scheduleForm">
          {Object.keys(scheduleWindow).length > 0 ? (
            <>
              <AutoCompleteDropdown
                optionList={scheduleDataStore?.scheduleData?.data}
                defaultValue={scheduleWindow?.name}
                cbk={scheduleWindowCbk}
                updateListBody={true}
                Body={rowProps => (
                  <ScheduleOptionRow {...rowProps} onEdit={setEditSchedule} />
                )}
              >
                <SchedulePresetList
                  onSelect={handleScheduleSelected}
                  onOpenCreateModal={() => setShowCreateSchedulePopup(true)}
                />
              </AutoCompleteDropdown>
              <div className="sendingWindow">
                <div className="scheduleHeader">Sending window</div>
                <div className="flexCenter">
                  <div className="scheduleWindowPanel">
                    {getScheduleWindow()}
                  </div>
                  <div className="timeZone">
                    Timezone: {scheduleWindow?.timezoneName || ""}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="autoCompleteDropdownLoading">
                <div className="inputBoxLoader linear-background" />
              </div>
              <div className="sendingWindowLoading">
                <div className="labelLoader linear-background" />
                {Array.from({ length: 7 }, (value, index) => (
                  <div
                    className="daysWithTimeWrapper"
                    key={`daysWithTimeWrapper${index}`}
                  >
                    <div className="weekDays linear-background" />
                    <div className="TimeRange linear-background" />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      </CollapsibleSettingCard>
      <CollapsibleSettingCard
        title="Sending safeguards"
        summary={safeguardSummary}
      >
        <div
          className="sequenceExcludeContactSafetySetting"
          id="excludeContactSetting"
        >
          <p className="subTextForSettings">
            Rules that automatically stop or skip contacts so you never email
            someone you shouldn't.
          </p>
          {safetyCheckboxList.map(
            item => item?.show && <SecondaryCheckbox key={item?.id} {...item} />
          )}
        </div>
      </CollapsibleSettingCard>
      <CollapsibleSettingCard title="Sending limits" summary={limitsSummary}>
        <div className="sequenceThrottlingSettings">
          <p className="subTextForSettings">
            New contacts start as Pending and move to Ongoing automatically,
            based on the limits below.
          </p>
          <div className="throttlingForm">
            <div className="inputForm">
              {settingsObjArr.map(item => {
                return <NumberInputBox {...item} key={item.id} />;
              })}
            </div>
          </div>
        </div>
      </CollapsibleSettingCard>
      <CreateSchedulePopup
        show={showCreateSchedulePopup || !!editSchedule}
        editItem={editSchedule}
        onClose={() => {
          setShowCreateSchedulePopup(false);
          setEditSchedule(null);
        }}
        onCreated={handleScheduleSelected}
        onUpdated={handleScheduleSelected}
      />
      {hasUnsavedChanges && (
        <div className="seqSettingsSaveBar">
          <span className="saveBarText">You have unsaved changes</span>
          <Button
            id="saveSeqSettingsBtn"
            name="saveSeqSettingsBtn"
            btnText="Save Changes"
            type="button"
            className={`saveSeqSettingsBtn ${loading ? "loading" : ""}`}
            loader={loading}
            click={saveSequenceSetting}
          />
        </div>
      )}
    </div>
  );
});

export default withRouter(SequenceThrottlingSettings);
export { SequenceThrottlingSettings };
